// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-grey-0: #FEFCFB;
  --color-grey-50: #F3F0ED;
  --color-grey-100: #EBE6E1;
  --color-grey-200: #D8D0CB;
  --color-grey-300: #B3AAA6;
  --color-grey-400: #938D8A;
  --color-grey-500: #77716E;
  --color-grey-600: #564F4D;
  --color-grey-700: #37322E;
  --color-grey-800: #211E1C;
  --color-grey-900: #100D0A;
  --color-orange-0: #FEF2EB;
  --color-orange-50: #FFEADE;
  --color-orange-100: #FFDECC;
  --color-orange-200: #FFBE99;
  --color-orange-300: #FFA673;
  --color-orange-400: #FF8D4C;
  --color-orange-500: #FF7020;
  --color-orange-600: #ED5B07;
  --color-orange-700: #CC4800;
  --color-orange-800: #B24000;
  --color-orange-900: #993800;
  --color-purple-0: #F4EEFB;
  --color-purple-50: #E5DAF1;
  --color-purple-100: #D0BFE3;
  --color-purple-200: #B59BD4;
  --color-purple-300: #A07DCA;
  --color-purple-400: #8653C0;
  --color-purple-500: #663399;
  --color-purple-600: #4C2673;
  --color-purple-700: #3D205B;
  --color-purple-800: #241839;
  --color-purple-900: #1A0C27;
  --color-red-0: #FBEFF1;
  --color-red-50: #F4D7DB;
  --color-red-100: #EFB3BD;
  --color-red-200: #E892A3;
  --color-red-300: #E87D92;
  --color-red-400: #DF6277;
  --color-red-500: #C23D53;
  --color-red-600: #A12137;
  --color-red-700: #7D1C2C;
  --color-red-800: #611429;
  --color-red-900: #411523;
  --color-green-0: #EAF5F0;
  --color-green-50: #DBF0E7;
  --color-green-100: #BDE5D4;
  --color-green-200: #A2D7C0;
  --color-green-300: #84C8AA;
  --color-green-400: #5FB490;
  --color-green-500: #40A57A;
  --color-green-600: #1E8559;
  --color-green-700: #196C48;
  --color-green-800: #165037;
  --color-green-900: #113123;
  --color-yellow-0: #FFF8EB;
  --color-yellow-50: #FFF0CC;
  --color-yellow-100: #FBE6BB;
  --color-yellow-200: #FFDA99;
  --color-yellow-300: #F8C977;
  --color-yellow-400: #EDB75A;
  --color-yellow-500: #E7A223;
  --color-yellow-600: #CE8E0D;
  --color-yellow-700: #886106;
  --color-yellow-800: #5E4508;
  --color-yellow-900: #382905;
  --color-bronze-0: #FBF0E9;
  --color-bronze-50: #F0E3DB;
  --color-bronze-100: #E7D2C5;
  --color-bronze-200: #D6B09A;
  --color-bronze-300: #CA997D;
  --color-bronze-400: #B68463;
  --color-bronze-500: #946442;
  --color-bronze-600: #825535;
  --color-bronze-700: #674228;
  --color-bronze-800: #492F1D;
  --color-bronze-900: #362417;
  --color-silver-0: #F0F0F0;
  --color-silver-50: #E5E5E5;
  --color-silver-100: #D8D6D5;
  --color-silver-200: #C8C7C6;
  --color-silver-300: #BEBBBB;
  --color-silver-400: #AAA7A7;
  --color-silver-500: #979595;
  --color-silver-600: #706C6C;
  --color-silver-700: #585555;
  --color-silver-800: #3E3C3C;
  --color-silver-900: #2F2D2D;
  --color-gold-0: #FBF5EA;
  --color-gold-50: #F9F0DC;
  --color-gold-100: #F3E7CE;
  --color-gold-200: #ECD6AC;
  --color-gold-300: #E2C998;
  --color-gold-400: #D9B981;
  --color-gold-500: #C6A76E;
  --color-gold-600: #A8904D;
  --color-gold-700: #76642D;
  --color-gold-800: #54431C;
  --color-gold-900: #382905;
  --color-diamond-0: #B0B2B5;
  --color-diamond-50: #9B9EA2;
  --color-diamond-100: #858A8E;
  --color-diamond-200: #767B7F;
  --color-diamond-300: #6B6F76;
  --color-diamond-400: #55595E;
  --color-diamond-500: #424448;
  --color-diamond-600: #37383A;
  --color-diamond-700: #28292A;
  --color-diamond-800: #1E1F1F;
  --color-diamond-900: #0A0A0A;
  --color-magenta-0: #F1DAE6;
  --color-magenta-50: #E2B6CE;
  --color-magenta-100: #D491B5;
  --color-magenta-200: #C66C9D;
  --color-magenta-300: #B84784;
  --color-magenta-400: #9D2F6A;
  --color-magenta-500: #8F2B61;
  --color-magenta-600: #762350;
  --color-magenta-700: #602042;
  --color-magenta-800: #4D1A35;
  --color-magenta-900: #2E0F20;
  --color-platinum-0: #DAEAF1;
  --color-platinum-50: #B5D6E3;
  --color-platinum-100: #90C1D5;
  --color-platinum-200: #6BACC7;
  --color-platinum-300: #4697B9;
  --color-platinum-400: #2E7D9E;
  --color-platinum-500: #2A7290;
  --color-platinum-600: #235E76;
  --color-platinum-700: #204D60;
  --color-platinum-800: #1A3D4D;
  --color-platinum-900: #0F252E;
  --color-brown-0: #F0D7C2;
  --color-brown-50: #E6BD99;
  --color-brown-100: #DFAB7C;
  --color-brown-200: #D99C63;
  --color-brown-300: #D28946;
  --color-brown-400: #B9702D;
  --color-brown-500: #985C25;
  --color-brown-600: #7B4A1E;
  --color-brown-700: #673E19;
  --color-brown-800: #523114;
  --color-brown-900: #3E250F;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@gol-smiles/tangerina-tokens/dist/web/globals/colors.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,wBAAwB;EACxB,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;AAC5B","sourcesContent":[":root {\n  --color-grey-0: #FEFCFB;\n  --color-grey-50: #F3F0ED;\n  --color-grey-100: #EBE6E1;\n  --color-grey-200: #D8D0CB;\n  --color-grey-300: #B3AAA6;\n  --color-grey-400: #938D8A;\n  --color-grey-500: #77716E;\n  --color-grey-600: #564F4D;\n  --color-grey-700: #37322E;\n  --color-grey-800: #211E1C;\n  --color-grey-900: #100D0A;\n  --color-orange-0: #FEF2EB;\n  --color-orange-50: #FFEADE;\n  --color-orange-100: #FFDECC;\n  --color-orange-200: #FFBE99;\n  --color-orange-300: #FFA673;\n  --color-orange-400: #FF8D4C;\n  --color-orange-500: #FF7020;\n  --color-orange-600: #ED5B07;\n  --color-orange-700: #CC4800;\n  --color-orange-800: #B24000;\n  --color-orange-900: #993800;\n  --color-purple-0: #F4EEFB;\n  --color-purple-50: #E5DAF1;\n  --color-purple-100: #D0BFE3;\n  --color-purple-200: #B59BD4;\n  --color-purple-300: #A07DCA;\n  --color-purple-400: #8653C0;\n  --color-purple-500: #663399;\n  --color-purple-600: #4C2673;\n  --color-purple-700: #3D205B;\n  --color-purple-800: #241839;\n  --color-purple-900: #1A0C27;\n  --color-red-0: #FBEFF1;\n  --color-red-50: #F4D7DB;\n  --color-red-100: #EFB3BD;\n  --color-red-200: #E892A3;\n  --color-red-300: #E87D92;\n  --color-red-400: #DF6277;\n  --color-red-500: #C23D53;\n  --color-red-600: #A12137;\n  --color-red-700: #7D1C2C;\n  --color-red-800: #611429;\n  --color-red-900: #411523;\n  --color-green-0: #EAF5F0;\n  --color-green-50: #DBF0E7;\n  --color-green-100: #BDE5D4;\n  --color-green-200: #A2D7C0;\n  --color-green-300: #84C8AA;\n  --color-green-400: #5FB490;\n  --color-green-500: #40A57A;\n  --color-green-600: #1E8559;\n  --color-green-700: #196C48;\n  --color-green-800: #165037;\n  --color-green-900: #113123;\n  --color-yellow-0: #FFF8EB;\n  --color-yellow-50: #FFF0CC;\n  --color-yellow-100: #FBE6BB;\n  --color-yellow-200: #FFDA99;\n  --color-yellow-300: #F8C977;\n  --color-yellow-400: #EDB75A;\n  --color-yellow-500: #E7A223;\n  --color-yellow-600: #CE8E0D;\n  --color-yellow-700: #886106;\n  --color-yellow-800: #5E4508;\n  --color-yellow-900: #382905;\n  --color-bronze-0: #FBF0E9;\n  --color-bronze-50: #F0E3DB;\n  --color-bronze-100: #E7D2C5;\n  --color-bronze-200: #D6B09A;\n  --color-bronze-300: #CA997D;\n  --color-bronze-400: #B68463;\n  --color-bronze-500: #946442;\n  --color-bronze-600: #825535;\n  --color-bronze-700: #674228;\n  --color-bronze-800: #492F1D;\n  --color-bronze-900: #362417;\n  --color-silver-0: #F0F0F0;\n  --color-silver-50: #E5E5E5;\n  --color-silver-100: #D8D6D5;\n  --color-silver-200: #C8C7C6;\n  --color-silver-300: #BEBBBB;\n  --color-silver-400: #AAA7A7;\n  --color-silver-500: #979595;\n  --color-silver-600: #706C6C;\n  --color-silver-700: #585555;\n  --color-silver-800: #3E3C3C;\n  --color-silver-900: #2F2D2D;\n  --color-gold-0: #FBF5EA;\n  --color-gold-50: #F9F0DC;\n  --color-gold-100: #F3E7CE;\n  --color-gold-200: #ECD6AC;\n  --color-gold-300: #E2C998;\n  --color-gold-400: #D9B981;\n  --color-gold-500: #C6A76E;\n  --color-gold-600: #A8904D;\n  --color-gold-700: #76642D;\n  --color-gold-800: #54431C;\n  --color-gold-900: #382905;\n  --color-diamond-0: #B0B2B5;\n  --color-diamond-50: #9B9EA2;\n  --color-diamond-100: #858A8E;\n  --color-diamond-200: #767B7F;\n  --color-diamond-300: #6B6F76;\n  --color-diamond-400: #55595E;\n  --color-diamond-500: #424448;\n  --color-diamond-600: #37383A;\n  --color-diamond-700: #28292A;\n  --color-diamond-800: #1E1F1F;\n  --color-diamond-900: #0A0A0A;\n  --color-magenta-0: #F1DAE6;\n  --color-magenta-50: #E2B6CE;\n  --color-magenta-100: #D491B5;\n  --color-magenta-200: #C66C9D;\n  --color-magenta-300: #B84784;\n  --color-magenta-400: #9D2F6A;\n  --color-magenta-500: #8F2B61;\n  --color-magenta-600: #762350;\n  --color-magenta-700: #602042;\n  --color-magenta-800: #4D1A35;\n  --color-magenta-900: #2E0F20;\n  --color-platinum-0: #DAEAF1;\n  --color-platinum-50: #B5D6E3;\n  --color-platinum-100: #90C1D5;\n  --color-platinum-200: #6BACC7;\n  --color-platinum-300: #4697B9;\n  --color-platinum-400: #2E7D9E;\n  --color-platinum-500: #2A7290;\n  --color-platinum-600: #235E76;\n  --color-platinum-700: #204D60;\n  --color-platinum-800: #1A3D4D;\n  --color-platinum-900: #0F252E;\n  --color-brown-0: #F0D7C2;\n  --color-brown-50: #E6BD99;\n  --color-brown-100: #DFAB7C;\n  --color-brown-200: #D99C63;\n  --color-brown-300: #D28946;\n  --color-brown-400: #B9702D;\n  --color-brown-500: #985C25;\n  --color-brown-600: #7B4A1E;\n  --color-brown-700: #673E19;\n  --color-brown-800: #523114;\n  --color-brown-900: #3E250F;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
